<div class="graphs-menu-panel">
  <ul nz-menu [nzMode]="'inline'" nzNoAnimation>
    <li nz-submenu *ngFor="let element of menu" [nzOpen]="isSelectedElement(element)">
      <span title>{{element.reportDisplayName}}</span>
      <ul>
        <li nz-menu-item *ngFor="let report of element.reports" [nzSelected]="isSelectedReport(report)" (click)="onSelect(report)">
          <i class="chart-icon" [ngClass]="getChartIcon(report)"></i>
          {{report.name}}
        </li>
      </ul>
    </li>
  </ul>
</div>
